__turbopack_context__.v({
  "cardBorder": "SecFeatureIntro-module-scss-module__SlDicq__cardBorder",
  "cardDescription": "SecFeatureIntro-module-scss-module__SlDicq__cardDescription",
  "cardOverlay": "SecFeatureIntro-module-scss-module__SlDicq__cardOverlay",
  "cardShell": "SecFeatureIntro-module-scss-module__SlDicq__cardShell",
  "cardTitle": "SecFeatureIntro-module-scss-module__SlDicq__cardTitle",
  "container": "SecFeatureIntro-module-scss-module__SlDicq__container",
  "enter": "SecFeatureIntro-module-scss-module__SlDicq__enter",
  "exit": "SecFeatureIntro-module-scss-module__SlDicq__exit",
  "fade-in": "SecFeatureIntro-module-scss-module__SlDicq__fade-in",
  "fade-out": "SecFeatureIntro-module-scss-module__SlDicq__fade-out",
  "fade-out-80": "SecFeatureIntro-module-scss-module__SlDicq__fade-out-80",
  "featureCard": "SecFeatureIntro-module-scss-module__SlDicq__featureCard",
  "glow": "SecFeatureIntro-module-scss-module__SlDicq__glow",
  "glowWrap": "SecFeatureIntro-module-scss-module__SlDicq__glowWrap",
  "grid": "SecFeatureIntro-module-scss-module__SlDicq__grid",
  "heading": "SecFeatureIntro-module-scss-module__SlDicq__heading",
  "headingBlock": "SecFeatureIntro-module-scss-module__SlDicq__headingBlock",
  "icon": "SecFeatureIntro-module-scss-module__SlDicq__icon",
  "iconWrap": "SecFeatureIntro-module-scss-module__SlDicq__iconWrap",
  "section": "SecFeatureIntro-module-scss-module__SlDicq__section",
  "slide-in-from-bottom": "SecFeatureIntro-module-scss-module__SlDicq__slide-in-from-bottom",
  "slide-in-from-left": "SecFeatureIntro-module-scss-module__SlDicq__slide-in-from-left",
  "slide-in-from-right": "SecFeatureIntro-module-scss-module__SlDicq__slide-in-from-right",
  "slide-in-from-top": "SecFeatureIntro-module-scss-module__SlDicq__slide-in-from-top",
  "slide-out-to-bottom": "SecFeatureIntro-module-scss-module__SlDicq__slide-out-to-bottom",
  "slide-out-to-left": "SecFeatureIntro-module-scss-module__SlDicq__slide-out-to-left",
  "slide-out-to-right": "SecFeatureIntro-module-scss-module__SlDicq__slide-out-to-right",
  "slide-out-to-top": "SecFeatureIntro-module-scss-module__SlDicq__slide-out-to-top",
  "subheading": "SecFeatureIntro-module-scss-module__SlDicq__subheading",
  "subheadingBlock": "SecFeatureIntro-module-scss-module__SlDicq__subheadingBlock",
  "zoom-in": "SecFeatureIntro-module-scss-module__SlDicq__zoom-in",
  "zoom-out": "SecFeatureIntro-module-scss-module__SlDicq__zoom-out",
});
